module.exports = __webpack_public_path__ + "img/OM.32667b17.svg";